export default function MySQL_ADDTIME() {
  return (
    <div>
      <h2>MySQL_ADDTIME</h2>    </div>
  );
}